import TableEmptyRow from 'components/others/TableEmptyRow';
import type { ServicePreviewRow } from '../model/types';
import ServicesTransferTableRow from './ServicesTransferTableRow';

interface ServicesTransferTableBodyProps {
    rows: ServicePreviewRow[];
    mode: 'preview' | 'result';
    emptyLabel: string;
    colService: string;
    colCount: string;
    colTeam: string;
    statusOk: string;
    statusFail: string;
    onToggle?: (key: string) => void;
}

const ServicesTransferTableBody = ({
    rows,
    mode,
    emptyLabel,
    colService,
    colCount,
    colTeam,
    statusOk,
    statusFail,
    onToggle,
}: ServicesTransferTableBodyProps) => {
    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-muted text-center py-3">
                    {emptyLabel}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <ServicesTransferTableRow
                    key={row.key}
                    row={row}
                    mode={mode}
                    colService={colService}
                    colCount={colCount}
                    colTeam={colTeam}
                    statusOk={statusOk}
                    statusFail={statusFail}
                    onToggle={onToggle}
                />
            ))}
        </tbody>
    );
};

export default ServicesTransferTableBody;
